<template>
  <v-app>
    <div id="app">
      <div id="app-container" class="container-lg p-0 new-theme">
        <Header />
        <div class="container-router">
          <div class="background-color"></div>
          <router-view :key="componentKey"> </router-view>
        </div>

        <Modal />
        <ModalLoading ref="modalLoading" />
      </div>
    </div>
  </v-app>
</template>

<script>
import Loading from "@/components/other/Loading";
import Header from "@/views/layout/Header";
import Redirect from "@/views/redirect";
import Modal from "@/components/modal";
import ModalLoading from "@/components/other/ModalLoading.vue";

export default {
  components: {
    Header,
    Modal,
    Loading,
    Redirect,
    ModalLoading
  },
  data() {
    return {
      isLoading: false,
      activePath: "",
      componentKey: 1
    };
  },
  watch: {
    "$route.path": {
      handler: function (to, from, val) {
        this.activePath = to;
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    // ****************** comment for connect lineliff ******************
    const path = window.location.pathname;
    const isPdfPath = /^\/pdf\/[^/]+\/[^/]+$/.test(path);
    if (!isPdfPath) {
      if (!this.$liff.isLoggedIn()) {
        return this.$liff.login({
          redirectUri: `${window.location.origin}?redirect=${
            window.location.pathname + window.location.search
          }`
        });
      }
      
      const lineProfile = await this.$liff.getProfile();
      this.$store.commit("setLineId", lineProfile);
    }
   
    this.isLoading = true;
  },
  mounted() {
    this.emitter.on("showLoading", (type, brand, isPdf) => {
      this.$refs.modalLoading.show();
    });
    this.emitter.on("hideLoading", () => this.$refs.modalLoading.hide());
  },
  computed: {
    readyToUse() {
      return this.isLoading;
    },
  },
  method: {

  }
};
</script>
<style>
.background-color {
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  min-height: 100vh;
  z-index: -1;
  background-color: var(--theme-background-color);
}
</style>
